import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { worldwideContinents, worldwideRegions } from '../data/mock';

export const WorldwideContinentPage = () => {
  const { continentId } = useParams();
  const continent = worldwideContinents.find(c => c.id === continentId);
  const regions = worldwideRegions.filter(r => r.continent === continentId);

  if (!continent) {
    return (
      <div>
        <Navigation />
        <div className="container" style={{ padding: '120px 0', textAlign: 'center' }}>
          <h1 className="hero-large">Continent Not Found</h1>
          <Link
  to="/worldwide-journeys"
  className="back-link"
  style={{ color: 'var(--text-secondary)' }}
>
  ← Back to Worldwide Journeys
</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navigation />
      <WhatsAppButton variant="floating" />

      {/* Hero Section */}
      <section style={{
        position: 'relative',
        height: '60vh',
        minHeight: '500px',
        background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${continent.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="container" style={{ textAlign: 'center', color: 'white', zIndex: 2 }}>
          <div style={{ marginBottom: '24px' }}>
            <Link
              to="/worldwide-journeys"
              style={{
                color: '#FBBF24',
                textDecoration: 'none',
                fontSize: '14px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#D4AF37'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#FBBF24'}
            >
              ← Back to Worldwide Journeys
            </Link>
          </div>
          <h1 className="hero-large" style={{ color: 'white', marginBottom: '24px' }}>
            {continent.name}
          </h1>
          <p className="hero-subtitle" style={{ color: 'rgba(255,255,255,0.95)', maxWidth: '800px', margin: '0 auto' }}>
            {continent.description}
          </p>
        </div>
      </section>

      {/* Regions Grid */}
      <section className="container" style={{ padding: '80px 0' }}>
        <h2 className="section-title" style={{ marginBottom: '48px' }}>Explore {continent.name} by Region</h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '32px'
        }}>
          {regions.map((region) => (
            <Link
              key={region.id}
              to={`/worldwide-journeys/${continentId}/${region.id}`}
              style={{
                position: 'relative',
                height: '400px',
                borderRadius: '4px',
                overflow: 'hidden',
                textDecoration: 'none',
                display: 'block',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              className="destination-card"
            >
              <img
                src={region.image}
                alt={region.name}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.9), transparent)',
                padding: '60px 32px 32px',
                color: 'white'
              }}>
                <h3 style={{
                  fontSize: '24px',
                  fontWeight: '400',
                  marginBottom: '12px',
                  color: 'var(--gold)'
                }}>
                  {region.name}
                </h3>
                <p style={{
                  fontSize: '14px',
                  lineHeight: '1.6',
                  marginBottom: '16px',
                  color: 'rgba(255,255,255,0.9)'
                }}>
                  {region.description}
                </p>
                <span style={{
                  color: 'var(--gold)',
                  fontSize: '14px',
                  letterSpacing: '0.5px'
                }}>
                  Explore region →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};
